import { RouteSearchModel } from '@/types/RouteServiceType'
import axios from 'axios'
import { ILoggingService } from './LoggingService'

export default class RouteService {
    private readonly _logging: ILoggingService
    private readonly baseUrl = '/route'

    constructor(logging: ILoggingService) {
        this._logging = logging
    }

    public async getSearchRoutes() : Promise< RouteSearchModel[]> {
        const url = `${this.baseUrl}/search`

        try {
            return (await axios.get<{result: RouteSearchModel[]}>(url)).data.result
        } catch(error){
            this._logging.LogError(url, error)
            throw error
        }
    }
}